import { CreateWeightOverageInvoiceParams } from '../TriplePInterface';

export interface CreateWeightOverageInvoicePayload {
  allowed_weight: number;
  dumped_weight: number;
}

export const toCreateWeightOverageInvoicePayload = (params: CreateWeightOverageInvoiceParams): CreateWeightOverageInvoicePayload => {
  return {
    allowed_weight: +params.form.allowedWeight,
    dumped_weight: +params.form.dumpedWeight
  };
}
